import React, { useState } from 'react';
import { Box, Typography, Button, Link as MuiLink } from '@mui/material';
import { clearAllTokens } from '../../utils/AuthUtils';
import { cognitoApiEndPoints } from '../../constants/ApiEndPoints';

const UserHasNoAccount: React.FC = () => {
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSignIn = (): void => {
    clearAllTokens();
    window.location.href = cognitoApiEndPoints.ssoLoginURL;
  };

  if (submitted) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', px: 3, textAlign: 'center', gap: 2 }}>
        <Typography variant="h5" fontWeight="bold" color="#001B33">
          Thank you for your message.
        </Typography>
        <Typography variant="body1" color="textSecondary">
          We will get back to you promptly.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', pt: '128px', pb: '80px' }}>
      <Box sx={{ width: { xs: '90%', sm: '70%', md: '50%' }, display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Typography variant="h4" fontWeight={350} color="#001B33">
          Account Setup Required
        </Typography>

        <Typography variant="body1" color="#001B33">
          Unfortunately, your account has not been properly set up. The email was automatically sent to support.
        </Typography>

        {error && (
          <Typography variant="body2" color="error">
            {error}
          </Typography>
        )}

        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
          <Button
            variant="contained"
            onClick={handleSignIn}
            sx={{
              borderRadius: 8,
              textTransform: 'none',
              fontWeight: 'bold',
              py: 1.2,
              px: 3,
              backgroundColor: '#007db3',
              '&:hover': {
                backgroundColor: '#00699a',
              },
            }}
          >
            Sign in with a different account
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default UserHasNoAccount;
